import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FieldErrorDisplayComponent } from "./field-error-display.component";

@NgModule({
  imports: [RouterModule, CommonModule],
  declarations: [FieldErrorDisplayComponent],
  exports: [FieldErrorDisplayComponent]
})
export class FieldErrorDisplayModule {}
